import { DocumentCellRendererComponent } from "../../../components/crm/companies/pages/company-info-tabs/document-cell-renderer/document-cell-renderer.component";
import { AgColDefsI, AgGridI } from "../ag-grid/ag-grid.model";


const commonColumnProperties = {
  suppressMovable: true,
  flex: 1,
}

const commonProperties150Width = {
  ...commonColumnProperties,
  sortable: true,
  minWidth: 150,
  cellStyle: { 'padding-left': "22px", 'color': '#646E76' },
  cellRenderer: (params: any) => params.value ? params.value : "&#8212",
}

const commonProperties200Width = {
  ...commonColumnProperties,
  sortable: true,
  minWidth: 200,
  cellStyle: { 'padding-left': "22px", 'color': '#646E76' },
  cellRenderer: (params: any) => params.value ? params.value : "&#8212",
}

const commonPrimaryColorColumnProperties = {
  ...commonColumnProperties,
  sortable: true,
  minWidth: 200,
  cellStyle: { 'color': 'var(--sitewide_primary_accent_color)', 'padding-left': "22px" },
  cellRenderer: (params: any) => params.value ? params.value : "&#8212",
}

const commonBooleanColumnProperties = {
  ...commonColumnProperties,
  minWidth: 200,
  sortable: true,
  cellStyle: { 'padding-left': "22px", 'color': '#646E76' },
  cellRenderer: (params: any) => params.value === true ? params.value : params.value === false ? params.value : "&#8212",
}

const svgColumn: AgColDefsI = {
  headerName: "",
  field: "svgSuccess",
  minWidth: 100,
  width: 100,
  suppressMovable: true,
  flex: 1,
  cellRenderer: DocumentCellRendererComponent,
};

const CurrencyColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Currency",
  field: "currency",
};

const TagsColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Tags",
  field: "tags",
};

const DescriptionColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Description",
  field: "description",
};

const CustomerColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Customer",
  field: "company",
};
const InternalPartNumberColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Internal Part Number",
  field: "internalPartNumber",
};

const REACHColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "REACH",
  field: "reach",
};
const MSLColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "MSL",
  field: "msl",
};

const SchedBColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Sched B",
  field: "schedb",
};
const LeadShapeColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Sched B",
  field: "LeadShape",
};
const DimensionsColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Dimensions",
  field: "dimensions ",
};
const StorageTempColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Storage Temp",
  field: "storageTemp ",
};
const BacklightingColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Backlighting",
  field: "backlighting ",
};
const BrightnessColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Brightness",
  field: "brightness  ",
};
const ResolutionColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Resolution",
  field: "resolution  ",
};
const ContrastRatioColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contrast Ratio",
  field: "contrastRatio  ",
};
const SupplyVoltageColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Supply Voltage",
  field: "supplyVoltage  ",
};
const SKUColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "SKU",
  field: "sku",
};

const AssetAccountColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Asset Account",
  field: "assetAccount",
};
const CostColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Cost",
  field: "cost",
};
const ExpenseAccountColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Expense Account",
  field: "expenseAccount",
};
const ListPriceColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "List Price",
  field: "listPrice",
};
const ResaleColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Resale",
  field: "resale",
};
const DiscountNameColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Discount Name",
  field: "discountName",
};
const QtyRelatedColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Qty Related",
  field: "qtyRelated",
};
const NameColumn : AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Name",
  field: "name",
};

const VendorColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Vendor",
  field: "company",
};

const ContactColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact",
  field: "contact",
};

const VPNColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "VPN",
  field: "vpn",
};
const ExpirationDateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Expiration Date",
  field: "expirationEndDate",
};

const PayoutPercentageColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Payout Percentage",
  field: "payoutPercentage",
};
const PaidasPercentageofSaleColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Paid as Percentage of Sale",
  field: "PaidasPercentageofSale",
};

const MFRColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "MFR",
  field: "mfr",
};

const PartStatusColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Part Status",
  field: "partStatus",
};

const StandardPackagingColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Standard Packaging",
  field: "standardPackaging",
};

const DevicePackagingColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Device Packaging",
  field: "devicePackaging",
};

const MOQColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "MOQ",
  field: "moq",
};

const NotesColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Notes",
  field: "notes",
};

const TempGradeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Temp Grade",
  field: "tempGrade",
};

const MountTypeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Mount Type",
  field: "mountType",
};

const LotCodeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Lot Code",
  field: "lotCode",
};

const SPQColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "SPQ",
  field: "spq",
};

const DateCodeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Date Code",
  field: "dateCode",
};

const UnitCostColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Unit Cost",
  field: "unitCost",
};

const ReceivedPackagingColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Received Packaging",
  field: "receivedPackaging",
};

const ReceivedInColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Received In",
  field: "receivedIn",
};

const WarehouseColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Warehouse",
  field: "warehouse",
};

const UOMColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "UOM",
  field: "uom",
};

const LocationColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Location",
  field: "location",
};

const QtyColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Quantity",
  field: "qty",
};

const RoHSColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "RoHS",
  field: "roHS",
};

const CompanyColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Company",
  field: "company",
};

const ConditionColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Condition",
  field: "condition",
};

const COOColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "COO",
  field: "coo",
};

const ContractEndDateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contract End Date",
  field: "contactEndDate",
};

const CPNColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "CPN",
  field: "cpn",
};

const OriginalPriceColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Original Price",
  field: "originalPrice",
};

const PayoutPriceColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Payout Price",
  field: "payoutPrice",
};

const NSNColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "NSN",
  field: "nsn",
};

const RevisionColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Revision",
  field: "revision",
};

const ExchangeRateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Exchange Rate",
  field: "exchangeRate",
};

const CategoryGroupColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Category Group",
  field: "categoryGroup",
};

const ParentCategoryColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Parent Category",
  field: "parentCategory",
};

const CategoryColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Category",
  field: "category",
};

const SubCategoryColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Sub Category",
  field: "subCategory",
};
const PinCountColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Pin Count",
  field: "pincount",
};

const HTSColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "HTS",
  field: "hts",
};

const ScheduleBColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Schedule B",
  field: "scheduleB",
};

const ECCNColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "ECCN",
  field: "eccn",
};

const TempRangeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Temp Range",
  field: "tempRange",
};

const MPNCommonColumn: AgColDefsI = {
  ...commonPrimaryColorColumnProperties,
  headerName: "MPN",
  field: "mpn",
};

const DateofOfferColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Date of Offer",
  field: "DateofOffer",
};

const CommentsColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Comments",
  field: "comments",
};
const QtyOfferedColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Qty Offered",
  field: "qtyOffered",
};

const ConvertedCostColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Converted Cost",
  field: "converted Cost",
};

const ItemPkgColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Item Pkg",
  field: "itemPkg",
};
const LotColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Lot",
  field: "lot",
};
const  VendorLeadTimeColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: " Vendor Lead Time",
  field: " vendorLeadTime",
};
const  WarrantyColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Warranty",
  field: "warranty",
};

const  LabelColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Label",
  field: "label",
};
const  TraceDocumentColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Trace Document",
  field: "traceDocument",
};
const  TraceablePartColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Traceable Part",
  field: "traceablePart",
};
const  RecentTestReportColumn: AgColDefsI = {
  ...commonBooleanColumnProperties,
  headerName: "Recent Test Report",
  field: "recentTestReport",
};

export const PartsColDefsPreview: AgColDefsI[] = [
  svgColumn,
  MPNCommonColumn,
  MFRColumn,
  PartStatusColumn,
  InternalPartNumberColumn,
  DescriptionColumn,
  StandardPackagingColumn,
  DevicePackagingColumn,
  TempGradeColumn,
  SPQColumn,
  MOQColumn,
  MountTypeColumn,
  NotesColumn,
  RoHSColumn,
  REACHColumn,
  MSLColumn,
  COOColumn,
  NSNColumn,
  HTSColumn,
  SchedBColumn,
  ECCNColumn,
  TagsColumn,
  CategoryGroupColumn,
  ParentCategoryColumn,
  SubCategoryColumn,
  PinCountColumn,
  LeadShapeColumn,
  DimensionsColumn,
  StorageTempColumn,
  BacklightingColumn,
  BrightnessColumn,
  ResolutionColumn,
  ContrastRatioColumn,
  SupplyVoltageColumn,
  SKUColumn,
  UOMColumn,
  CostColumn,
  AssetAccountColumn,
  ExpenseAccountColumn,
  ListPriceColumn,
  ResaleColumn,
  DiscountNameColumn,
  QtyRelatedColumn,
  NameColumn,
]

export const ConsignmentColDefsPreview: AgColDefsI[] = [
  svgColumn,
  CompanyColumn,
  ContactColumn,
  ContractEndDateColumn,
  MPNCommonColumn,
  MFRColumn, 
  CPNColumn,
  OriginalPriceColumn,
  WarehouseColumn,
  LocationColumn,
  ReceivedInColumn,
  ReceivedPackagingColumn,
  NotesColumn,
  PayoutPriceColumn,
  PayoutPercentageColumn,
  PaidasPercentageofSaleColumn,
]

export const OEMExcessColDefsPreview: AgColDefsI[] = [
  svgColumn,
  CustomerColumn,
  ContactColumn,
  ExpirationDateColumn,
  MPNCommonColumn,
  MFRColumn,
  CPNColumn,
  QtyColumn,
  UnitCostColumn,
  RoHSColumn,
  DateCodeColumn,
  LotCodeColumn,
  NotesColumn,
]

export const InventoryColDefsPreview: AgColDefsI[] = [
  svgColumn,
  VendorColumn,
  ContactColumn,
  MPNCommonColumn,
  MFRColumn,
  WarehouseColumn,
  LocationColumn,
  ReceivedInColumn,
  UnitCostColumn,
  ReceivedPackagingColumn,
  NotesColumn,
]

export const VendorPartsColDefsPreview: AgColDefsI[] = [
  svgColumn,
  VendorColumn,
  ContactColumn,
  ExpirationDateColumn,
  MPNCommonColumn,
  MFRColumn,
  VPNColumn,
  QtyColumn,
  UnitCostColumn,
  RoHSColumn,
  DateCodeColumn,
  LotCodeColumn,
  NotesColumn,
]

export const OfferColDefsPreview: AgColDefsI[] = [
  svgColumn,
  DateofOfferColumn,
  VendorColumn,
  ContactColumn,
  CommentsColumn,
  QtyOfferedColumn,
  CostColumn,
  CurrencyColumn,
  ExchangeRateColumn,
  ConvertedCostColumn,
  MPNCommonColumn,
  MFRColumn,
  ConditionColumn,
  ConditionColumn,
  RoHSColumn,
  NSNColumn,
  ConditionColumn,
  ItemPkgColumn,
  COOColumn,
  DescriptionColumn,
  RevisionColumn,
  LotColumn,
  VendorLeadTimeColumn,
  WarrantyColumn,
  CategoryGroupColumn,
  ParentCategoryColumn,
  CategoryColumn,
  SubCategoryColumn,
  SPQColumn,
  MOQColumn,
  HTSColumn,
  ScheduleBColumn,
  ECCNColumn,
  TempRangeColumn,
  PartStatusColumn,
  LabelColumn,
  TraceDocumentColumn,
  TraceablePartColumn ,
  RecentTestReportColumn,
]

export const AgGridImportCommonPreview: AgGridI = {
  colDefs: PartsColDefsPreview,
  rowSelection: "multiple",
};

export const AgGridImportConsignmentPreview: AgGridI = {
  colDefs: ConsignmentColDefsPreview,
  rowSelection: "multiple",
};

export const AgGridImportOEMExcessPreview: AgGridI = {
  colDefs: OEMExcessColDefsPreview,
  rowSelection: "multiple",
};

export const AgGridImportInventoryPreview: AgGridI = {
  colDefs: InventoryColDefsPreview,
  rowSelection: "multiple",
};

export const AgGridImportVendorPartsPreview: AgGridI = {
  colDefs: VendorPartsColDefsPreview,
  rowSelection: "multiple",
};
export const AgGridImporOffersPreview: AgGridI = {
  colDefs: OfferColDefsPreview,
  rowSelection: "multiple",
};